import gql from 'graphql-tag';

// FIXME: Use mutation hook
export const mutation = gql`
  mutation UpdateJobPlacement($input: UpdateJobPlacementInput!) {
    updateJobPlacement(input: $input) {
      ... on UpdateJobPlacementResponseSuccess {
        result
      }
      ... on ResponseError {
        error
      }
    }
  }
`;
